import { render, staticRenderFns } from "./ManageHeaderFooter.vue?vue&type=template&id=139d14f8&scoped=true"
import script from "./ManageHeaderFooter.vue?vue&type=script&lang=js"
export * from "./ManageHeaderFooter.vue?vue&type=script&lang=js"
import style0 from "./ManageHeaderFooter.vue?vue&type=style&index=0&id=139d14f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139d14f8",
  null
  
)

export default component.exports